import React from 'react';
import {ChevronDown, ChevronUp} from '../Icons';

interface IChevronToggleProps {
    version?: string;
    onV3ChevronClick?: (newIndex: number) => void;
    handleScrollToElement?: (elementId: string) => void;
    v3ClickedChevron?: number;
    index?: number;
    isShrinked: boolean;
}

export const ChevronToggle: React.FC<IChevronToggleProps> = ({
    onV3ChevronClick,
    handleScrollToElement,
    index = 0,
    isShrinked
}) => {
    const handleChevronClick = async (
        e: React.MouseEvent,
        shrinkedClick?: boolean
    ) => {
        e.stopPropagation();

        if (!onV3ChevronClick) return;

        if (shrinkedClick) {
            onV3ChevronClick(10);
            return;
        }

        // Wait for `onV3ChevronClick` to complete
        await onV3ChevronClick(index);

        if (handleScrollToElement) {
            const elementId = `lp-alib-content-tiers-card-item-index-${index}`;
            handleScrollToElement(elementId);
        }
    };

    return (
        <>
            {isShrinked ? (
                <ChevronDown
                    onClick={(e: React.MouseEvent) => handleChevronClick(e)}
                />
            ) : (
                <ChevronUp
                    onClick={(e: React.MouseEvent) =>
                        handleChevronClick(e, true)
                    }
                />
            )}
        </>
    );
};
